import Text from 'components/Text/Text';
import React from 'react';
import { IRestaurantCategory } from 'types';
import style from './CategoriesScrollView.module.scss';

interface ICategoriesScrollView {
	data: IRestaurantCategory[];
}

const CategoriesScrollView: React.FC<ICategoriesScrollView> = ({ data }) => {
	return (
		<div className={style.container}>
			{data.length
				? data.map((el) => (
						<div key={el.id} className={style.item}>
							<div className={style.dot} />
							<Text translationKey={el.name} withTooltip={true} />
						</div>
				  ))
				: '-'}
		</div>
	);
};

export default React.memo(CategoriesScrollView);
